import { makeStyles } from "@mui/styles";

export const usePreviewStyles = makeStyles((theme) => ({
  button: {
    "&:hover": {
      color: theme.palette.highlight.main,
    },
  },
}));

export const dialogPaperStyle = {
  height: "100%",
  backgroundColor: "#000000",
  margin: 0,
  maxHeight: "none",
};

export const dialogTitleSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
};

export const imageTitleSx = {
  flex: 1,
  textAlign: "center",
  ml: 10,
};

export const titleActionsSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
};

export const floatingActionButtonSx = {
  color: "#ffffff",
  backgroundColor: "#00000066",
  "&:hover": {
    backgroundColor: "#00000099",
  },
};

export const tagsContainerSx = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  alignContent: "center",
};

export const centeredFlexSx = {
  alignContent: "center",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
};

export const rightAlignedSx = {
  textAlign: "right",
};

export const dialogActionsSx = {
  justifyContent: "center",
};

export const previewContainerSx = {
  position: "relative",
  height: "100%",
};

export const previewImageSx = (imageUrl) => ({
  background: 'url("' + imageUrl.replace(/\+/g, "%2B") + '")no-repeat',
});

const baseNavButtonSx = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  color: "#ffffff",
  backgroundColor: "#00000066",
  "&:hover": {
    backgroundColor: "#00000099",
  },
};

export const prevNavButtonSx = {
  ...baseNavButtonSx,
  left: 8,
};

export const nextNavButtonSx = {
  ...baseNavButtonSx,
  right: 8,
};
